import {record} from 'rrweb';
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { v4 as uuidv4 } from "uuid";

/**
 * Uploads a JSON object to S3 using temporary credentials.
 * @param {Object} credsOutput - The JSON from /get-upload-credentials
 * @param {Object} data - Arbitrary JS object to store
 */
async function uploadJsonToS3(credsOutput, data) {
  const { folder, bucket, region, credentials } = credsOutput;

  // Step 1: Initialize S3 client with temporary credentials
  const s3 = new S3Client({
    region,
    credentials: {
      accessKeyId: credentials.AccessKeyId,
      secretAccessKey: credentials.SecretAccessKey,
      sessionToken: credentials.SessionToken
    }
  });

  // Step 2: Prepare file content
  const jsonString = JSON.stringify(data);
  const fileName = `${folder}/${Date.now()}.json`;

  // Step 3: Upload to S3
  const command = new PutObjectCommand({
    Bucket: bucket,
    Key: fileName,
    Body: jsonString,
    ContentType: "application/json"
  });

  await s3.send(command);

  return fileName;
}

const RRWEB_CRED_ENDPOINT = '/get-upload-credentials';

function credFetcher() {
  let creds = null;
  let fetchTime = 0;
  return async function innerCredMaker() {
    if (creds != null) {
      let elapsedDuration = (Date.now() - fetchTime)/1000;
      if (creds.duration > elapsedDuration) {
        // still valid
        return creds;
      }
    }
    creds = await fetch(RRWEB_CRED_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' }).then(r => {
      //if (r.status === 200) {
      //  return r.json();
      //} else {
      //  return r.json().then(j => Promise.reject(j.error));
      //}
      return r.json();
    });
    fetchTime = Date.now();
    await (new Promise(res => setTimeout(res, 1000)));
    return creds;
  }
}

export default function initRrweb(){
  console.log('initRrweb called');
  
  window.__curBinKey = Date.now();
  window.__eventCache = {
    [window.__curBinKey]:[]
  };
  window.__streamProgressCache = {};
  window.__EVENT_STREAM_PENDING = 12;

  let credMaker = credFetcher();

  function logEventLocally(event){
    let curBinKey = window.__curBinKey;
    let eventCache = window.__eventCache;
    let curCache = eventCache[curBinKey];
    if( !curCache ){
      eventCache[curBinKey] = [];
      curCache = eventCache[curBinKey];
    }
    curCache.push(event);
  }


  function getStreamEventsAndUpdateStreamProgress(){

    let curBinKey = window.__curBinKey;
    let eventCache = window.__eventCache;
    let streamProgressCache = window.__streamProgressCache;

    let eventsToStream = {};


    for( let binKey in eventCache ){
      let notCurrentlyStreamingBin = streamProgressCache[binKey] !== window.__EVENT_STREAM_PENDING;
      let thisBinIsNotTheCurrentBin = binKey !== curBinKey;
      let binIsEmpty = eventCache[binKey].length === 0;

      if( thisBinIsNotTheCurrentBin && notCurrentlyStreamingBin && !binIsEmpty ){


        streamProgressCache[binKey] = window.__EVENT_STREAM_PENDING;
        eventsToStream[binKey] = eventCache[binKey]
      }

      if( binIsEmpty && thisBinIsNotTheCurrentBin ){
        delete eventCache[binKey];
      }
    }

    return eventsToStream;

  }

  async function streamEvents(){
    window.__curBinKey = Date.now();
    let eventsToStream = getStreamEventsAndUpdateStreamProgress();

    if( Object.keys(eventsToStream).length === 0 ){
      return;
    }

    const body = JSON.stringify({ data: (eventsToStream) })

    let creds = await credMaker();
    uploadJsonToS3(creds, body);

    //return;

    //fetch(RRWEB_ENDPOINT, {
    //  method:'POST',
    //  credentials:'include',
    //  headers:{
    //    'Content-Type':'application/json;charset=utf-8'

    //  },
    //  body
    //})
    //  .then(resp => {
    //    if( resp.status === 204 ){
    //      onStreamSuccess(eventsToStream);
    //    }else{
    //      //;
    //      onStreamFailed(eventsToStream);
    //    }
    //  })
    //  .catch(err => {
    //    console.log("SEND DOM EVENTS ERROR");
    //    console.log(err);
    //    onStreamFailed(eventsToStream)

    //  })

  }

  window.__streamEvents = streamEvents;

  function onStreamSuccess(eventsToStream){
    let streamProgressCache = window.__streamProgressCache;
    let eventCache = window.__eventCache;

    for(let streamedBin in eventsToStream){
      delete streamProgressCache[streamedBin];
      delete eventCache[streamedBin];
    }

  }

  function onStreamFailed(eventsToStream){

    let streamProgressCache = window.__streamProgressCache;

    Object.keys(eventsToStream).forEach(binKey => {
      delete streamProgressCache[binKey]
    })

  }




  record({
    emit(event){
      logEventLocally(event);
    }
  }, { maskInputOptions:{ password:true }})


  window.__eventStreamInterval = setInterval(
    window.__streamEvents,10000
  );


}
